import script from "./MGTextField.vue?vue&type=script&setup=true&lang=ts"
export * from "./MGTextField.vue?vue&type=script&setup=true&lang=ts"

import "./MGTextField.vue?vue&type=style&index=0&id=060fc4c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-060fc4c7"]])

export default __exports__